import { useState, useEffect } from "react";

interface Size {
  width: number;
  height: number;
}
// Hook
export default function useWindowSize(): Size {
  const [windowSize, setWindowSize] = useState<Size>({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
}

export const GetCurrentWindowSize = () => {
  const size = useWindowSize();
  if (size.width >= 1024) {
    return "lg";
  } else if (size.width < 1024 && size.width >= 768) {
    return "md";
  } else {
    return "sm";
  }
};
